<div class="integrations-filter__container-outer">
  <form [formGroup]="form" class="integrations-filter__container-inner">
    <div class="integrations-filter__filter" *ngFor="let used of usedFilters; let uIdx = index">
      <button class="integrations-filter__filter-remove  vox-btn vox-btn-secondary-grey" type="button"
        (click)="removeFilter(uIdx)" [ngClass]="{'hidden': usedFilters.length === 1}">
        <i class="integrations-filter__filter-remove_symbol icon-small-remove"></i>
      </button>
      <div ngbDropdown class="vox-dropdown-input integrations-filter__filter-dropdown">
        <button class="integrations-filter__filter-dropdown_btn" id="filter-dropdown" ngbDropdownToggle
          [disabled]="availableFilters.length < 1">
          {{'integrations.filters.fields.' + used | translate}}
        </button>
        <div ngbDropdownMenu aria-labelledby="filter-dropdown">
          <button ngbDropdownItem class="integrations-filter__filter-dropdown_item" type="button"
            *ngFor="let filter of availableFilters; let idx = index" (click)="updateFilters(idx, uIdx)">
            {{'integrations.filters.fields.' + filter | translate}}
          </button>
        </div>
        <div class="integrations-filter__filter-input" [ngSwitch]="used">
          <div class="vox-input-group vox-input-group_dense">
            <input class="vox-text-field" type="text" formControlName="company_id" *ngSwitchCase="'company_id'"
              (keydown.enter)="emitFilters($event)">
          </div>
          <div class="vox-input-group vox-input-group_dense">
              <gdp-select-integration-platforms formControlName="platform_id" *ngSwitchCase="'platform_id'" [platforms]="platforms">
              </gdp-select-integration-platforms>
          </div>
          <div class="vox-input-group vox-input-group_dense">
            <gdp-select-integration-enabled formControlName="enabled" *ngSwitchCase="'enabled'">
            </gdp-select-integration-enabled>
          </div>
          <div class="vox-input-group vox-input-group_dense">
            <gdp-select-integration-status formControlName="status" *ngSwitchCase="'status'">
            </gdp-select-integration-status>
          </div>
        </div>
      </div>
    </div>
    <div class="integrations-filter__filter-add_container">
      <button class="vox-btn vox-btn-secondary integrations-filter__filter-add" type="button" (click)="addFilter(0)"
        [disabled]="availableFilters.length < 1">
        <i class="integrations-filter__filter-add_symbol icon-small-add">
        </i>
      </button>
      <button class="vox-btn vox-btn-secondary integrations-filter__filter-apply" type="submit"
        [disabled]="form.invalid || !usedFilters.length" (click)="emitFilters(null)">
        {{'integrations.filters.actions.apply-filters' | translate}}
      </button>
      <button class="ml-2 btn btn-link integrations-filter__filter-clear" type="button" (click)="resetFilters()">
        {{'integrations.filters.actions.clear-filters' | translate}}
      </button>
    </div>
  </form>
</div>
